import React from 'react';
import { useToastStore } from '@/shared/stores/toastStore';
import { CustomError } from '@/shared/components/atoms';
import './ToastContainer.css';

export const ToastContainer: React.FC = () => {
    const { toasts } = useToastStore();

    if (toasts.length === 0) return null;

    return (
        <div className="app-toast-container">
            {toasts.map((toast) => (
                <CustomError
                    key={toast.id}
                    variant="toast"
                    title={toast.title || (toast.type === 'error' ? 'Error' : 'Notification')}
                    message={toast.message}
                    className={`toast--${toast.type}`}
                />
            ))}
        </div>
    );
};
